/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PostApiPublicAppointmentUpload$Params {

/**
 * The appointment uuid
 */
  uuid: string;
  '_locale': 'de' | 'en' | 'fr';
      body: {

/**
 * file to upload
 */
'myFile': Blob;

/**
 * fieldName
 */
'fieldName': string;

/**
 * a number for subforms , 0 for mainform
 */
'subFormNumber': number;
}
}

export function postApiPublicAppointmentUpload(http: HttpClient, rootUrl: string, params: PostApiPublicAppointmentUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postApiPublicAppointmentUpload.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('_locale', params['_locale'], {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postApiPublicAppointmentUpload.PATH = '/api/public/{_locale}/appointment/{uuid}/upload';
